module.exports = __webpack_public_path__ + "img/waitingRoom_default.d1784f68.png";